import { patchExportMethods } from '@/utils/exportLoading'

/**
 * 自动为 export* / handleExport / doExport 方法注入统一导出 loading。创建于 2026-08-29
 */
export default {
  beforeCreate() {
    patchExportMethods(this.$options.methods)
  },
}
